import { render, staticRenderFns } from "./bottom-tip.vue?vue&type=template&id=8d612402&scoped=true"
import script from "./bottom-tip.vue?vue&type=script&lang=js"
export * from "./bottom-tip.vue?vue&type=script&lang=js"
import style0 from "./bottom-tip.vue?vue&type=style&index=0&id=8d612402&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d612402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d612402')) {
      api.createRecord('8d612402', component.options)
    } else {
      api.reload('8d612402', component.options)
    }
    module.hot.accept("./bottom-tip.vue?vue&type=template&id=8d612402&scoped=true", function () {
      api.rerender('8d612402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/bottom-tip.vue"
export default component.exports